module.exports = __webpack_public_path__ + "static/img/push.9655561.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme1/push.png
// module id = yEMX
// module chunks = 73